import React, { useEffect, useState } from 'react';
import { useQuery } from 'hooks/useQuery';
import { BillingService } from 'services';
import { UnauthenticatedPage } from 'pages/layouts';
import { ShowHide } from 'components/layout';
import { RedirectPanel } from 'components/navigation';
import { FailurePanel } from 'components/notifications';
import { redirect } from 'utils/redirect';

const pendingText = 'Redirecting you to your payment...';
const errorText = 'This transaction is no longer available';

export function PaymentRedirectPage() {
    const query = useQuery();
    const transactionId = query.get('transactionId');
    const [hasError, setHasError] = useState(false);

    useEffect(() => {
        if (!transactionId) {
            setHasError(true);
            return;
        }

        // The catch covers both a failed token request and a payment URL that redirect
        // rejects for not being https, so either surfaces the standard error state.
        BillingService.generateToken(transactionId)
            .then((response) => {
                redirect(response.paymentUrl);
            })
            .catch(() => {
                setHasError(true);
            });
    }, []);

    return (
        <UnauthenticatedPage>
            <ShowHide
                evaluator={!hasError}
                show={
                    <RedirectPanel
                        heading="Taking you to your payment"
                        message={pendingText}
                    />
                }
            />
            <ShowHide
                evaluator={hasError}
                show={
                    <FailurePanel title="Payment unavailable">
                        <p>{errorText}</p>
                    </FailurePanel>
                }
            />
        </UnauthenticatedPage>
    );
}
